<template>
  <div id="app" :class="{ 'dark': isDarkMode }">
    <router-view />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore();
const isDarkMode = computed(() => themeStore.isDarkMode);

onMounted(() => {
  // Initialize theme from localStorage
  themeStore.initializeTheme();
});
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
